export default "__VITE_ASSET__BxCeznav__"